import Ws from '@adonisjs/websocket-client';
import api from '../../services/api.service';

function Socket() {
  let ws;

  function socketConnection(authToken) {
    ws = Ws(`ws${process.env.NODE_ENV !== 'production' ? '' : 's'}://${api.domain}`);
    ws.withJwtToken(authToken).connect();
    ws.on('open', () => {});
  }

  function subscribe(topic) {
    if (ws) {
      const getSubscription = ws.getSubscription(topic);
      if (!getSubscription) {
        return ws.subscribe(topic);
      }
      return getSubscription;
    }
  }

  return {
    initSocketConnection(authToken) {
      if (!ws) {
        socketConnection(authToken);
      }
    },
    getSocketConnection() {
      return {
        ws,
        subscribe: topic => subscribe(topic),
      };
    },
  };
}

export default Socket();



// WEBPACK FOOTER //
// ./src/utils/webSocketsMiddleware/socketConnection.js